document.addEventListener("DOMContentLoaded", function () {
  /* =========================================
     PRODUCT / COLLECTION GRID SWITCHER
  ========================================= */

  const fourGrid = document.querySelector(".custom_four_grid");
  const listGrid = document.querySelector(".custom_list_grid");
  const threeGrid = document.querySelector(".custom_three_grid");
  const productGrid = document.querySelector(".product-grid");

  if (fourGrid && productGrid) {
    fourGrid.addEventListener("click", function () {
      fourGrid.classList.add("custom_active");

      if (threeGrid) {
        threeGrid.classList.remove("custom_active");
      }

      if (listGrid) {
        listGrid.classList.remove("custom_active");
      }

      productGrid.classList.remove(
        "grid--3-col-desktop",
        "custom-list-grid"
      );

      productGrid.classList.add(
        "grid",
        "grid--2-col-tablet-down",
        "grid--4-col-desktop"
      );
    });
  }

  if (listGrid && productGrid) {
    listGrid.addEventListener("click", function () {
      listGrid.classList.add("custom_active");

      if (fourGrid) {
        fourGrid.classList.remove("custom_active");
      }

      if (threeGrid) {
        threeGrid.classList.remove("custom_active");
      }

      productGrid.classList.remove(
        "grid",
        "grid--2-col-tablet-down",
        "grid--3-col-desktop",
        "grid--4-col-desktop"
      );

      productGrid.classList.add("custom-list-grid");
    });
  }


  /* =========================================
     MANUAL DESKTOP TABS
  ========================================= */

  class TabsManual {
    constructor(tablist) {
      this.tablist = tablist;

      this.tabs = Array.from(
        tablist.querySelectorAll('[role="tab"]')
      );

      this.tabs.forEach((tab) => {
        const panelId = tab.getAttribute("aria-controls");
        const panel = document.getElementById(panelId);

        if (!panel) {
          console.warn("Panel not found:", panelId);
          return;
        }

        tab.setAttribute("aria-selected", "false");
        tab.tabIndex = -1;

        panel.classList.add("is-hidden");

        tab.addEventListener("click", () => {
          this.activateTab(tab);
        });

        tab.addEventListener("keydown", (event) => {
          this.onKeyDown(event);
        });
      });

      if (this.tabs.length) {
        this.activateTab(this.tabs[0]);
      }
    }

    activateTab(tab) {
      this.tabs.forEach((currentTab) => {
        const panelId =
          currentTab.getAttribute("aria-controls");

        const panel =
          document.getElementById(panelId);

        if (!panel) {
          return;
        }

        currentTab.setAttribute(
          "aria-selected",
          "false"
        );

        currentTab.tabIndex = -1;

        panel.classList.add("is-hidden");
      });

      const selectedPanelId =
        tab.getAttribute("aria-controls");

      const selectedPanel =
        document.getElementById(selectedPanelId);

      if (!selectedPanel) {
        return;
      }

      tab.setAttribute(
        "aria-selected",
        "true"
      );

      tab.removeAttribute("tabindex");

      selectedPanel.classList.remove(
        "is-hidden"
      );
    }

    onKeyDown(event) {
      const currentIndex =
        this.tabs.indexOf(event.currentTarget);

      let nextIndex = currentIndex;

      switch (event.key) {
        case "ArrowRight":
          nextIndex =
            (currentIndex + 1) %
            this.tabs.length;
          break;

        case "ArrowLeft":
          nextIndex =
            (currentIndex - 1 + this.tabs.length) %
            this.tabs.length;
          break;

        case "Home":
          nextIndex = 0;
          break;

        case "End":
          nextIndex =
            this.tabs.length - 1;
          break;

        default:
          return;
      }

      event.preventDefault();

      this.tabs[nextIndex].focus();

      this.activateTab(
        this.tabs[nextIndex]
      );
    }
  }

 document
  .querySelectorAll('[role="tablist"].manual')
  .forEach((tablist) => {

    /* Custom product tabs already have
       their own JavaScript inside custom_tab.liquid */
    if (tablist.closest('[id^="CustomTabs-"]')) {
      return;
    }

    new TabsManual(tablist);
  });

  /* =========================================
     IMPORTANT:
     MOBILE ACCORDION HANDLER REMOVED HERE

     The Custom Tab section already controls:
     .accordionItemHeading
     .accordionItem.open
     .accordionItem.close

     Do NOT add another accordion click handler
     here because it causes double toggling.
  ========================================= */


  /* =========================================
     NO PRODUCTS FOUND MESSAGE
  ========================================= */

  const noProductsTitle =
    document.querySelector(
      "h2.title.title--primary"
    );

  if (
    noProductsTitle &&
    noProductsTitle.textContent.includes(
      "No products found"
    )
  ) {
    noProductsTitle.textContent =
      "Dropping on 5th December";

    noProductsTitle.classList.add(
      "not_found"
    );
  }


  /* =========================================
     PRODUCT PRICE
  ========================================= */

  const priceEl =
    document.querySelector(
      "[data-product-price]"
    );

  if (priceEl) {
    priceEl.style.display = "";
  }

  document.addEventListener(
    "variant:change",
    function () {
      const updatedPriceEl =
        document.querySelector(
          "[data-product-price]"
        );

      if (updatedPriceEl) {
        updatedPriceEl.style.display = "";
      }
    }
  );
});


